import { render, staticRenderFns } from "./placard_lookdetails.vue?vue&type=template&id=61e3537c&scoped=true"
import script from "./placard_lookdetails.vue?vue&type=script&lang=js"
export * from "./placard_lookdetails.vue?vue&type=script&lang=js"
import style0 from "./placard_lookdetails.vue?vue&type=style&index=0&id=61e3537c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3537c",
  null
  
)

export default component.exports